import axios from "axios";
import { clearData } from "../stores/userStore";

const server = axios.create({
  // baseURL: "http://localhost:5000",
  baseURL: "https://pakagus-server.tec.my.id",
  timeout: 100000,
});

server.interceptors.request.use(function (request) {
  return request;
});

server.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    console.log(err);
    if (err.response) {
      // if session expired
      if (err.response.status === 440 || err.response.status === 401) {
        clearData()
        window.location.href = "/";
      } else {
        throw err.response.data.message
      }
    } else {
      alert("Error: ada kesalahan");
    }
  }
);

export default server;
